import { Component } from '@angular/core';

@Component({
    selector: 'app-nozzleliners-data',
    templateUrl: './nozzleliners-data.component.html',
    styleUrl: './nozzleliners-data.component.css',
    standalone: false
})
export class NozzlelinersDataComponent {

}
